import { buildAnchorId } from '@/components/helpers'
import { Indices } from '@/components/search/helpers'
import { cn } from '@repo/ui/utils'
import { ReactNode } from 'react'

export function HighlightedText({
  text,
  indices,
  currentMatchIndex = 0,
  anchorPrefix = '',
}: {
  text: string
  indices: Indices[]
  currentMatchIndex?: number
  anchorPrefix?: string
}): ReactNode {
  if (!indices || !indices.length) return <>{text}</>

  const parts = []
  let lastIndex = 0

  for (let i = 0; i < indices.length; i++) {
    const match = indices[i]
    if (!match) continue
    const [start, end] = match
    if (start > lastIndex) {
      parts.push(text.substring(lastIndex, start))
    }
    const anchorId = buildAnchorId(anchorPrefix, i)

    parts.push(
      <span
        key={start}
        id={anchorId}
        className={cn(
          'inline-flex items-center outline-none',
          i === currentMatchIndex ? 'bg-yellow-400' : 'bg-yellow-200',
        )}
      >
        {text.substring(start, end + 1)}
      </span>,
    )
    lastIndex = end + 1
  }

  if (lastIndex < text.length) {
    parts.push(text.substring(lastIndex))
  }

  return <>{parts}</>
}
